import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
// import SideBar from "./components/Sidebar/SideBar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import environment from "./enviroment";
import Index from "./pages/Router/Index";
// import UserView from "./pages/user/userview/UserView";
// import UserList from "./pages/user/userList";

// import OrderDetails from "./pages/order/details/detail";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
//IMPORT USER  ROUTES COMPONENT
// import User from "./parentPages/User";

// import UserEdit from "./pages/user/edit/edit";
// import UserCreate from "./pages/user/create/create";

// IMPORT PRODUCT ROUTES COMPONENT
// import Product from "./parentPages/Product";
// import ProductList from "./pages/product/list/list";
// import ProductEdit from "./pages/product/edit/edit";
// import Items from "./pages/product/items/items";
// import ProductDetail from './pages/product/detail/detail'
// import ProductCreate from "./pages/product/create/create";

// IMPORT ORDER ROUTES COMPONENT

// import Order from "./parentPages/order";
// import OrderList from "./pages/order/list/list";
// import OrderDetails from "./pages/order/details/detail";

//IMPORTING PAYMENT ROUTES COMPONENT
// import Payment from "./parentPages/payment";
// import PaymentCreate from "./pages/payment/create/create";
// import PaymentList from "./pages/payment/list/list";
// import PaymentEdit from "./pages/payment/edit/edit";

//IMPORTING INVOICE ROUTES COMPOENT
// import Invoice from "./parentPages/invoice";
// import InvoiceList from "./pages/invoice/list/list";
// import InvoiceDetail from "./pages/invoice/detail/detail";

//IMPORTING LOGIN COMPONENT
import Login from "./Component/login/Login";

//IMPORTING VISIT COMPONENT

// import Visit from "./parentPages/Visit";
// import VisitCreate from "./pages/visit/create/create";
// import VisitEdit from "./pages/visit/edit/edit";
// import VisitList from "./pages/visit/list/list";
// import VisitView from "./pages/visit/ViewVisit/view";
// import LiveLocation from "./pages/visit/liveLocation/view"

import PrivateRoute from "./parentPages/privateRoute";
import { useEffect } from "react";

import { addCurrentUser } from "./Component/redux/astroSlice";

//IMPORTING SERVICES



//***********************************NEW WORKING FROM HERE ***************************** */


//PROFILE

import ParentProfile  from "./parentPage2/profile";
import Profile from "./pages2/Profile/profile";


//HOME 

import ParentHome from "./parentPage2/home";
import Home from "./pages2/Home/home";



// MYACTIVITY 
import ParentMyActivity from "./parentPage2/myActivity";
import ProfileByview from "./pages2/MyActivity/profileView";
import ContactView from "./pages2/MyActivity/contactView";
import MyInterest from "./pages2/MyActivity/myInterest";
import ProfileShortlisted from "./pages2/MyActivity/ProfileShortlist";
import ProfileIgnore from "./pages2/MyActivity/profileIgnore";

//OTHER ACTIVITY

import ParentOtherActivity from "./parentPage2/otherActivity";
import OtherProfileView from "./pages2/OthersAcitivity/profileView";
import OtherContactView from "./pages2/OthersAcitivity/contactView";
import ShowInterest  from "./pages2/OthersAcitivity/showsInterest";

//MESSAGE 

import ParentMessage from "./parentPage2/message";
import Message from "./pages2/Message/message";

//PAYMENT

import ParentPayment from "./parentPage2/payment";
import MYPackage from "./pages2/Payment/myPackage";
import Mypayment from "./pages2/Payment/myPayment";

//PREMIUM
import ParentPremium from "./parentPage2/premium";
import Premium from "./pages2/GoPremium/premium";




//UPLOAD AND ACCESS
import ParentUploadAndAccess from "./parentPage2/uploadAndAccess";
import UploadAndAccess from "./pages2/Upload&Access/uploadAndAccess";

//ACCOUNT SETTINGS

import ParentAccountSetting from "./parentPage2/accountSetting";
import PasswordAndNotification from "./pages2/AccountSetting/passwordAndNotification";
import FilterSetting from "./pages2/AccountSetting/filterSetting";

//HELP
import ParentHelp from "./parentPage2/help";
import Help from "./pages2/Help/help";



//Trust Badge
import TrustBadge from "./pages2/Profile/trustBadge";


//Other profile

import OtherProfile from "./pages2/otherProfile/profile"




// USER

 



// Working ON Client Halal India

import ClientProfile from "./Hala_india_Dashboard/Client_Portal/Profile/profilePrimay";
import CertificatePrimary from "./Hala_india_Dashboard/Client_Portal/Certification/cetificatePrimary";
import DashboardClient from "./Hala_india_Dashboard/Client_Portal/Dashboard/dashboardClient";

// WORKING WITH CRM

import DashboardCRM from "./Hala_india_Dashboard/CRM_Portal/Dashboard/primaryDashboardCRM";
import PrimaryLeadCRM from "./Hala_india_Dashboard/CRM_Portal/Leads/primaryLeadCRM";
import PrimaryClientPortalCRMPage from "./Hala_india_Dashboard/CRM_Portal/ClientPortalPage/PrimaryClientPortalCRMpage";


// WORKING WITH PRE AUDIT DEPARTMENT

// import DashboardPreAudit from "./Hala_india_Dashboard/Pre_Audit_Portal/";
import PrimaryclientPortalPreAudit from "./Hala_india_Dashboard/Pre_Audit_Portal/ClientPortalPage/PrimaryClientPortalCRMpage"
import DashboardPreAudit from "./Hala_india_Dashboard/Pre_Audit_Portal/Dashboard/primaryDashboardCRM"



// WORKING WITH POST AUDIT DEPARTMENT

import PrimaryClientPortalPostAudit from "./Hala_india_Dashboard/postAudit_portal/ClientPortalPage/PrimaryClientPortalCRMpage"
import DashboardPostAudit from "./Hala_india_Dashboard/postAudit_portal/Dashboard/primaryDashboardCRM"
import LeadsPostAudit from "./Hala_india_Dashboard/postAudit_portal/Leads/primaryLeadCRM"



// WORKING WITH PRE R&D AUDIT

import PrimaryClientPreRandDAudit from "./Hala_india_Dashboard/Audit_portal/ClientPortalPage/PrimaryClientPortalCRMpage"
import DashboardPreRandDAudit from "./Hala_india_Dashboard/Audit_portal/Dashboard/primaryDashboardCRM"
import LeadsPreRandDAudit from "./Hala_india_Dashboard/Audit_portal/Leads/primaryLeadCRM"

// Working with SHARIAH

import PrimaryClientShariah from "./Hala_india_Dashboard/Sharia_portal/ClientPortalPage/PrimaryClientPortalCRMpage"
import DashboardShariah from "./Hala_india_Dashboard/Sharia_portal/Dashboard/primaryDashboardCRM"
import LeadsShariah from "./Hala_india_Dashboard/Sharia_portal/Leads/primaryLeadCRM"



// WORKING WITH FINANCE DEPARTMENT

import PrimaryClientFinance from "./Hala_india_Dashboard/Finance_Portal/ClientPortalPage/PrimaryClientPortalCRMpage"
import DashbaordFinance from "./Hala_india_Dashboard/Finance_Portal/Dashboard/primaryDashboardCRM"
import LeadFinance from "./Hala_india_Dashboard/Finance_Portal/Leads/primaryLeadCRM"

//  WORKING WITH USER OF SUPER ADMIN

import PrimaryUserSuperAdmin from "./Hala_india_Dashboard/Master_Admin_Portal/User/PrimaryUser";

// Cache working page checking

import CompanyDetailsForm from "./Hala_india_Dashboard/Client_Portal/Profile/Company_Detail/companyDetailPrimary";
import DirectorDetailsForm from "./Hala_india_Dashboard/Client_Portal/Profile/Director_Detail/directoryDetail";
import PdfViewerPage from "./Hala_india_Dashboard/Client_Portal/Certification/Aggrement & NDAs/nonDisclouser";
// import CompanyProfile from "./Hala_india_Dashboard/Client_Portal/Certification/HalalCertificationForm/companyProfile";

import CompanyProfile from "./Hala_india_Dashboard/Client_Portal/Certification/HalalCertificationForm/companyProfile";
import ManufacturingProfile from "./Hala_india_Dashboard/Client_Portal/Certification/HalalCertificationForm/manufacturingProfile";
import CorrespondaceProfile from "./Hala_india_Dashboard/Client_Portal/Certification/HalalCertificationForm/correspondancePerson";
import ProductInfoProfile from "./Hala_india_Dashboard/Client_Portal/Certification/HalalCertificationForm/productInfo";

import ProductListing from "./Hala_india_Dashboard/Client_Portal/Certification/service_Listing/productListing";
import RawMaterialListing from "./Hala_india_Dashboard/Client_Portal/Certification/service_Listing/rawMaterial";
import ProductSpecification from "./Hala_india_Dashboard/Client_Portal/Certification/service_Listing/productSpecification";
import COA from "./Hala_india_Dashboard/Client_Portal/Certification/service_Listing/certificateOfAnalysis";
import PostAuditDeclaration from "./Hala_india_Dashboard/Client_Portal/Certification/service_Listing/postAudit";

import SupplierDeclaration from "./Hala_india_Dashboard/Client_Portal/Certification/service_Listing/SupplierDeclaration";
import NavigationLayout from "./calendernav";


import SettingsPage from "./Hala_india_Dashboard/common/profile";



function  DashboardAccordingOfUser(role){
  const roleBasedComponents = {
    ADMIN: <Home />,
    CLIENT: <DashboardClient />,
    CRM: <DashboardCRM />,
    PREAUDIT: <DashboardPreAudit />,
    FINANCE: <DashbaordFinance />,
    AUDIT: <DashboardPreRandDAudit />,
    POSTAUDIT:<DashboardPostAudit/>,
    SHARIA:<DashboardShariah/>
  };

  return roleBasedComponents[role] || <DashboardPreAudit/>;
}



function  LeadsAccordingOfUser(role){
  const roleBasedComponents = {
    ADMIN: <PrimaryLeadCRM />,
    CLIENT: <PrimaryLeadCRM />,
    SHARIA: <LeadsShariah />,
    AUDIT: <LeadsPreRandDAudit />,
    PREAUDIT: <PrimaryLeadCRM />,
    POSTAUDIT:<LeadsPostAudit/>,
    FINANCE:<LeadFinance/>
  
  };

  return roleBasedComponents[role] || <PrimaryLeadCRM/>;
}




function  ClientPortalAccordingOfUser(role){
  const roleBasedComponents = {

    ADMIN: <PrimaryclientPortalPreAudit />,
    CRM: <PrimaryClientPortalCRMPage />,
    CLIENT: <PrimaryclientPortalPreAudit />,
    SHARIA: <PrimaryClientShariah />,
    AUDIT: <PrimaryClientPreRandDAudit />,
    PREAUDIT: <PrimaryclientPortalPreAudit />,
    POSTAUDIT:<PrimaryClientPortalPostAudit/>,
    FINANCE:<PrimaryClientFinance/>,
  };

  return roleBasedComponents[role] || <PrimaryclientPortalPreAudit/>;
}


function  ProfileAccordingtoUser(role){
  const roleBasedComponents = {


    CLIENT: <ClientProfile />,
   
  };

  return roleBasedComponents[role] || <SettingsPage/>;
}



function App() {
  const dispatch = useDispatch();
 
  async function fetchMasterData() {
    const CurrentUser = JSON.parse(localStorage.getItem("user"));
    dispatch(addCurrentUser(CurrentUser));
  }

  
  useEffect(() => {
    fetchMasterData();
  },[]);


   const currentUser = useSelector((state) => state.astro.currentUser);



  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />, // Default component for /
    },
    {
      path: "/dashboard",
      element: <Index />,
  
      children: [
      
  
  //HERE THE NEW  WORK STARTED
  
        
        {
          path: "home", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: DashboardAccordingOfUser(currentUser?.role) , // Default component for /user
            },
          
          ],
        },
  



        {
          path: "lead", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: LeadsAccordingOfUser(currentUser?.role) , // Default component for /user
            },
          
          ],
        },




        {

          path: "ClientPortal", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: ClientPortalAccordingOfUser(currentUser?.role) , // Default component for /user
            },
          
          ],
          
        },
  
  
        {
          path: "dashboardClient", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <DashboardClient />, // Default component for /user
            },
          
          ],
        },


        {
          path: "user", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentHelp/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <PrimaryUserSuperAdmin />, // Default component for /user
            },
  
            // {
            //    path:"employee",
            //    element:<PrimaryUserSuperAdmin/>
            // }
          ],
         
        },
  
  
  
  
  
        {
          path: "companyDetail", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <DirectorDetailsForm />, // Default component for /user
            },
          
          ],
        },
  
        {
          path: "componentCheck", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <PdfViewerPage />, // Default component for /user
            },
          
          ],
        },
  
        {
          path: "directorDetail", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <CompanyDetailsForm />, // Default component for /user
            },
          
          ],
        },
  
  
  
        {
          path: "companyProfile", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <PdfViewerPage />, // Default component for /user
            },
          
          ],
        },
  
  
        {
          path: "CompanyProfileForm", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <CompanyProfile />, // Default component for /user
            },
          
          ],
        },
  
  
  
        {
          path: "manufacturingProfile", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <ManufacturingProfile />, // Default component for /user
            },
          
          ],
        },
  
  
        {
          path: "correspondanceProfile", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <CorrespondaceProfile />, // Default component for /user
            },
          
          ],
        },
  
  
        {
          path: "productInfo", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <ProductInfoProfile />, // Default component for /user
            },
          
          ],
        },
  
  
  
        
        {
          path: "ProductListing", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <ProductListing />, // Default component for /user
            },
          
          ],
        },
  
  
        {
          path: "rawMaterialListing", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <RawMaterialListing />, // Default component for /user
            },
          
          ],
        },
  
  
  
  
        {
          path: "ProductSpecification", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <ProductSpecification />, // Default component for /user
            },
          
          ],
        },
  
  
  
        {
          path: "coa", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <COA />, // Default component for /user
            },
          
          ],
        },
  
  
  
        {
          path: "PostAuditDeclaration", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <PostAuditDeclaration />, // Default component for /user
            },
          
          ],
        },
  
  
  
  
        {
          path: "supplierDeclaration", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <SupplierDeclaration />, // Default component for /user
            },
          
          ],
        },
  
  
  
        {
          path: "profile", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
       


            children: [
              {
                index: true,
                element: ProfileAccordingtoUser(currentUser?.role)  // Default component for /user
              },
            
            ],
  
  
         
        },
  
  
        {
          path: "certificate", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <CertificatePrimary />, // Default component for /user
            },
          ],
        },
  
  
  
        {
          path: "crm", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <DashboardCRM />, // Default component for /user
            },
          ],
        },
  
  
        {
          path: "primaryLeadCRM", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <PrimaryLeadCRM />, // Default component for /user
            },
          ],
        },
  
  
        {
          path: "PrimaryUser", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <PrimaryUserSuperAdmin />, // Default component for /user
            },
          ],
        },
  
  
  
  
        {
          path: "calenderWork", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentHome />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <NavigationLayout/>, // Default component for /user
            },
          ],
        },
  
  
  
     
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
        {
          path: "myProfile", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentOtherActivity/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <Profile />, // Default component for /user
            },
          ],
        },
  
  
        
        {
          path: "profile/:id", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentOtherActivity/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <OtherProfile />, // Default component for /user
            },
          ],
        },
  
  
  
        {
          path: "myActivity", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentMyActivity/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <ProfileByview />, // Default component for /user
            },
  
  
            {
              path: "contactView",
              element: <ContactView />,
            },
  
            {
              path: "shortlist",
              element: <ProfileShortlisted />,
            },
  
            {
              path: "interest",
              element: <MyInterest />,
            },
  
  
            {
              path: "ignore",
              element: <ProfileIgnore />,
            },
          
          ],
        },
  
        {
          path: "otherActivity", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentOtherActivity/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <OtherProfileView />, // Default component for /user
            },
  
  
            {
              path: "contactView",
              element: <OtherContactView />,
            },
  
  
            {
              path: "interest",
              element: <ShowInterest />,
            },
          
          ],
        },
  
  
        {
          path: "message", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentMessage/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <Message />, // Default component for /user
            },  
          ],
        },
  
  
  
        {
          path: "payment", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentPayment/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <Mypayment />, // Default component for /user
            },
  
  
            {
              path: "mypackage",
              element: <MYPackage />,
            },
          
          ],
        },
  
  
  
        
        {
          path: "accountSetting", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentAccountSetting/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: < PasswordAndNotification/>, // Default component for /user
            },
  
  
            {
              path: "filter",
              element: < FilterSetting/>,
            },
          
          ],
        },
  
  
        {
          path: "notification", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentPremium/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <Premium />, // Default component for /user
            },
          ],
        },
  
  
  
        {
          path: "uploadAndAccess", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              < ParentUploadAndAccess/>
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <UploadAndAccess />, // Default component for /user
            },
          ],
        },
  
  
  
  
  
        
  
  
  
  
        {
          path: "trustBadge", // Parent component for user routes, it should contain <Outlet />
          element: (
            <PrivateRoute>
              {" "}
              <ParentProfile />
            </PrivateRoute>
          ),
          children: [
            {
              index: true,
              element: <TrustBadge />, // Default component for /user
            },
          
          ],
        },
  
  
  
  
  
  
        {
          path: "*",
          element: <>Not Found</>,
        },
      ],
    },
  ]);




  useEffect(() => {
    // Function to handle tab visibility changes
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is inactive');
        // Handle the tab becoming inactive
      } else {
        console.log('Tab is active');
      
      }
    };

    // Add visibilitychange event listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);



  return <RouterProvider router={router} />;
}

export default App;
